import { render, staticRenderFns } from "./Dispute.vue?vue&type=template&id=1234c206&scoped=true&"
import script from "./Dispute.vue?vue&type=script&lang=ts&"
export * from "./Dispute.vue?vue&type=script&lang=ts&"
import style0 from "./Dispute.vue?vue&type=style&index=0&id=1234c206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1234c206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1234c206')) {
      api.createRecord('1234c206', component.options)
    } else {
      api.reload('1234c206', component.options)
    }
    module.hot.accept("./Dispute.vue?vue&type=template&id=1234c206&scoped=true&", function () {
      api.rerender('1234c206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Timeline/Dispute.vue"
export default component.exports